<script setup>
import { useRoute } from 'vue-router';
import { useMutation } from '@tanstack/vue-query';
import { API } from '@/services/index';
import { FORGOT_USER_PASSWORD } from '@/services/auth/mutations/index.js';

// .matches(/^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,10}$/, 'email must be a valid email'),

const formRules = {
  email: (value) => !!value || 'Email is required'
};

const route = useRoute();
const resetForm = ref();
const isFormValid = ref(false);
const email = ref(null);
const isPasswordRequested = ref(false);
const isLoading = ref(false);
const resetErrors = ref(null);
const inviteToken = route.query?.code ?? null;

const getPasswordResetLinkMutation = useMutation({
  mutationFn: async (payload) => {
    return await API.sendQuery('/graphql', FORGOT_USER_PASSWORD, payload);
  },
  onSuccess: (data) => {
    if (data.data.data.forgotPassword) {
      isPasswordRequested.value = true;
    }

    if (data.data.error) {
      // Helpers.showError(data.data.error.message);
      console.log(data.data.error);
      resetErrors.value = data.data.errors[0]?.extensions?.validation?.email[0];
    }
    isLoading.value = false;
  },
  onError: (error) => {
    console.log('error', error);
    isLoading.value = false;
  }
});

const getPasswordResetLinkHandler = () => {
  isLoading.value = true;
  getPasswordResetLinkMutation.mutateAsync({ email: email.value, invite_token: inviteToken });
};
</script>

<template>
  <div>
    <div v-if="resetErrors" class="tw-mt-2 tw-text-center tw-text-xs tw-font-bold tw-text-red-700">{{ resetErrors }}</div>
    <div v-if="isPasswordRequested" class="tw-mb-3 tw-mt-5 tw-text-center tw-text-[0.875rem] tw-font-semibold">
      Check your email for the link to reset your password.
    </div>
    <v-form class="tw-mt-5" ref="resetForm" v-model="isFormValid" @submit.prevent="getPasswordResetLinkHandler">
      <div class="tw-flex tw-w-full tw-flex-col">
        <v-text-field
          v-model="email"
          variant="outlined"
          color="primary-blue"
          placeholder="Email Address*"
          :rules="[formRules.email]"
          hide-details="auto"
          density="comfortable"
          :disabled="isLoading"
        >
        </v-text-field>
      </div>
      <div class="tw-mt-2 tw-flex tw-w-full">
        <v-btn
          color="primary-blue"
          size="large"
          rounded="lg"
          block
          flat
          class="text-capitalize font-weight-bold"
          style="letter-spacing: 0px"
          type="submit"
          :loading="isLoading"
          :disabled="isLoading || !isFormValid"
        >
          Reset Password
        </v-btn>
      </div>
    </v-form>
  </div>
</template>

<style lang="css" scoped></style>
